module.exports = __webpack_public_path__ + "78b2493da6703406b0f28dbdbc5b6fd0.svg";